// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNavCloseBtn {
    position: absolute;
    top: 0;
    font-size: 36px;
    margin-left: 22px;
    cursor: pointer;
    left: 15%;
}

.dragDropContainer {
    width: 250px;
    height: 250px;
    margin-left: 20px;
    margin-right: 20px;
}

.profileDetailFeedDiv {
    position: absolute;
    margin-left: 256px;
    margin-top: 350px;
}

.marginBottom30 {
    margin-bottom: 30px;
}

.marginHorizontal30 {
    margin-bottom: 30px;
    margin-top: 30px;
}

.bottomButtonFeed {
    color: white;
    background-color: #ec4655;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/FeedDetailedProfileView.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B","sourcesContent":[".sideNavCloseBtn {\n    position: absolute;\n    top: 0;\n    font-size: 36px;\n    margin-left: 22px;\n    cursor: pointer;\n    left: 15%;\n}\n\n.dragDropContainer {\n    width: 250px;\n    height: 250px;\n    margin-left: 20px;\n    margin-right: 20px;\n}\n\n.profileDetailFeedDiv {\n    position: absolute;\n    margin-left: 256px;\n    margin-top: 350px;\n}\n\n.marginBottom30 {\n    margin-bottom: 30px;\n}\n\n.marginHorizontal30 {\n    margin-bottom: 30px;\n    margin-top: 30px;\n}\n\n.bottomButtonFeed {\n    color: white;\n    background-color: #ec4655;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
